module.exports = __webpack_public_path__ + "static/media/help-icon.bad44d15.svg";